import { ProductTypeAttributes } from "src/interfaces/bold/attributes/attribute";
import { IdName } from "src/interfaces/bold/idName";
import { CountryRespone as CountryResponse, IdNameDictionary, ProductClassResponse, ProductCreateRequest, ProductLineRepsone, ProductResponse, ProductsResponse, ProductTypeResponse } from "src/interfaces/bold/product/product";
import { createProduct, getAllProducts, getAttributes, getAttribuesByProductType, getCountries, getDataTypes, getOrderReferenceData, getProductById, getProductClasses, getProductLines, getProductReferenceData, getProductStatuses, getProductTypes, getReturnOrderReferenceData, getSupplierReferenceData, getUnits, MAX_PAGESIZE, searchProducts, updateProduct, getProductLineById, getDiscontinuedProducts } from "src/utils/apiRequests";
import useGetAllPaginatedItemsLegacy from "../useGetAllPaginatedItems";
import useResponse, { useResponseLegacy } from "../useResponse";

// GET
export const useGetProductClasses = () => {
    return useResponseLegacy<ProductClassResponse[]>(getProductClasses);
}
export const useGetProductSubClasses = (productClassId: number) => {
    return useResponseLegacy<IdNameDictionary[]>(getProductTypes, { productClassId });
}
export const useGetProductTypes = () => {
    return useResponseLegacy<ProductTypeResponse[]>(getProductTypes);
}
export const useGetProductLines = (dependecy = null) => {
    return useResponseLegacy<ProductLineRepsone[]>(getProductLines);
}
export const useGetProductLineById = (id) => {
    const [item] = useResponseLegacy<ProductLineRepsone>(getProductLineById, { id }, true);
    return item;
}

export const useGetProductStatuses = () => {
    return useResponseLegacy<IdName[]>(getProductStatuses);
}
export const useGetProductById = (id: string, dependecy = null) => {
    const [item] = useResponseLegacy<ProductResponse>(getProductById, { id }, true, dependecy);
    return item

}
export const useGetAllProducts = () => {
    return useGetAllPaginatedItemsLegacy<ProductsResponse>(getAllProducts, MAX_PAGESIZE);
}
export const useGetDiscontinuedProducts = (shouldRequest: boolean) => {
    const result = useGetAllPaginatedItemsLegacy<ProductsResponse>(getDiscontinuedProducts, MAX_PAGESIZE, "ProductId", null, shouldRequest);
    if (!shouldRequest) return { rows: null, status: "idle" };
    return result;
};
export const useLatestProducts = (amount = 5) => {
    const { rows: result } = useResponse<any[]>({ requestFunction: getAllProducts, values: { amount, pageSize: 1 }, requestNothingOnNull: true });
    return result;
}
export const useSearchProducts = (searchKey: string) => {
    return useResponseLegacy<ProductsResponse[]>(searchProducts, { searchKey });
}

export const useGetCountries = () => {
    const [response] = useResponseLegacy<CountryResponse[]>(getCountries);
    return response;
}
export const useGetAttributes = () => {
    return useResponseLegacy<any[]>(getAttributes);
}
export const useGetAttributesByProductType = (productTypeId: string) => {
    const [attributes] = useResponseLegacy<ProductTypeAttributes>(getAttribuesByProductType, { productTypeId }, true, productTypeId);
    return attributes?.Properties
}
export const useGetUnits = () => {
    return useResponseLegacy<any[]>(getUnits);
}
export const useGetDataTypes = () => {
    const { rows: result } = useResponse<any[]>({ requestFunction: getDataTypes });
    // console.log("DataTypes", result);
    return result ?? [];
}
export const useGetProductReferenceData = () => {
    return useResponseLegacy<any>(getProductReferenceData);
}
export const useGetOrderReferenceData = () => {
    return useResponseLegacy<any>(getOrderReferenceData);
}
export const useGetSupplierReferenceData = () => {
    return useResponseLegacy<any>(getSupplierReferenceData);
}
export const useGetReturnOrderReferenceData = () => {
    return useResponseLegacy<any>(getReturnOrderReferenceData);
}


// POST
export const useCreateProduct = (productCreateRequest: ProductCreateRequest) => {
    return useResponseLegacy<ProductResponse>(createProduct, { productCreateRequest });
}
// PUT
export const useUpdateProduct = (id: number, productUpdateRequest: ProductCreateRequest) => {
    return useResponseLegacy<ProductResponse>(updateProduct, { id, productUpdateRequest });
}